import { Component, OnInit } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'mida-auth-wrapper',
  standalone: true,
  imports: [],
  templateUrl: './auth-wrapper.component.html',
  styleUrl: './auth-wrapper.component.scss',
})
export class AuthWrapperComponent implements OnInit {
  public currentYear = new Date().getFullYear();

  ngOnInit(): void {
    gsap.fromTo(
      'section',
      {
        y: -10,
      },
      {
        y: 10,
        duration: 1.5,
        ease: 'power4.inOut',
      }
    );
  }
}
